import React from 'react';
import classNames from 'classnames';
import styles from './LoginDisplay.module.scss';
import { Button, Icon } from 'ui/components';
import LoginIcon from 'ui/icons/icon_not_logged_in.svg';
import ProfileIcon from 'ui/icons/icon_logged_in.svg';
import CloseIcon from 'ui/icons/icon_close_cross.svg';

export interface LoginDisplayProps {
	className?: string;
	onSignIn: () => void;
	onSignOut: () => void;
	setProfileVisiblity: (isVisible: boolean) => void;
	isProfileVisible: boolean;
	profile?: {
		name?: string | null;
		email?: string | null;
		image?: string | null;
	};
}

export const LoginDisplay: React.FC<LoginDisplayProps> = ({ className, profile, onSignIn, onSignOut, isProfileVisible, setProfileVisiblity }) => {
	function handleSignOut() {
		setProfileVisiblity(false);
		onSignOut();
	}

	const texts = {
		authenticated: 'You are logged in',
		unauthenticated: 'You are not logged in',
		logOut: 'Log out',
		close: 'Close',
	};

	function LoginButton() {
		if (profile) {
			return (
				<button
					className={classNames(styles.Login_button, styles.Login_button___isLoggedIn)}
					onClick={() => setProfileVisiblity(true)}
					aria-label={texts.authenticated}
				>
					<Icon size="md">
						<ProfileIcon />
					</Icon>
				</button>
			);
		} else {
			return (
				<button className={classNames(styles.Login_button)} onClick={onSignIn} aria-label={texts.unauthenticated}>
					<Icon size="md">
						<LoginIcon />
					</Icon>
				</button>
			);
		}
	}

	return (
		<div className={classNames(styles.Login, className)}>
			<LoginButton />
			{profile && (
				<>
					<div className={classNames(styles.Login_window, isProfileVisible && styles.Login_window___visible)}>
						<div className={styles.Login_header}>
							<p className={styles.Login_heading}>{texts.authenticated}</p>
							<button className={styles.Login_closeBtn} onClick={() => setProfileVisiblity(false)} aria-label={texts.close}>
								<Icon size="md">
									<CloseIcon />
								</Icon>
							</button>
						</div>
						<div className={styles.Login_profile}>
							<div className={styles.Login_profileItem}>{profile.name}</div>
							<div className={styles.Login_profileItem}>{profile.email}</div>
						</div>
						<div className={styles.Login_logout}>
							<Button style="primary" className={styles.Login_logoutButton} onClick={() => handleSignOut()}>
								{texts.logOut}
							</Button>
						</div>
					</div>
					<div
						className={classNames(styles.Login_overlay, isProfileVisible && styles.Login_overlay___visible)}
						onClick={() => setProfileVisiblity(false)}
					></div>
				</>
			)}
		</div>
	);
};
